// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AcknowledgeDisclaimerData, AcknowledgeDisclaimerErrors, AcknowledgeDisclaimerResponses, CallbackData, CallbackResponses, CheckData, CheckErrors, CheckResponses, ExternalUserData, ExternalUserErrors, ExternalUserResponses, ForgotPasswordData, ForgotPasswordErrors, ForgotPasswordResponses, GenerateApiKeyData, GenerateApiKeyErrors, GenerateApiKeyResponses, ImpersonateData, ImpersonateErrors, ImpersonateResponses, LoginData, LoginErrors, LoginResponses, LogoutData, LogoutErrors, LogoutResponses, MigrateUserData, MigrateUserErrors, MigrateUserResponses, ProvidersData, ProvidersErrors, ProvidersResponses, RenewData, RenewErrors, RenewResponses, RequestEmailVerificationData, RequestEmailVerificationErrors, RequestEmailVerificationResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, VerifyEmailData, VerifyEmailErrors, VerifyEmailResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Check if a login token is valid
 */
export const check = <ThrowOnError extends boolean = false>(options?: Options<CheckData, ThrowOnError>) => (options?.client ?? client).get<CheckResponses, CheckErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/check',
    ...options
});

/**
 * List all the available providers
 */
export const providers = <ThrowOnError extends boolean = false>(options: Options<ProvidersData, ThrowOnError>) => (options.client ?? client).get<ProvidersResponses, ProvidersErrors, ThrowOnError>({ url: '/providers', ...options });

/**
 * Login in to IsardVDI
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>) => (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/login',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Create a isard user with an external identity provider
 */
export const externalUser = <ThrowOnError extends boolean = false>(options?: Options<ExternalUserData, ThrowOnError>) => (options?.client ?? client).post<ExternalUserResponses, ExternalUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/external/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * This method is used as a callback for external identity providers
 */
export const callback = <ThrowOnError extends boolean = false>(options: Options<CallbackData, ThrowOnError>) => (options.client ?? client).get<CallbackResponses, unknown, ThrowOnError>({ url: '/callback', ...options });

/**
 * Renew the user session and obtain a new valid JWT
 */
export const renew = <ThrowOnError extends boolean = false>(options: Options<RenewData, ThrowOnError>) => (options.client ?? client).post<RenewResponses, RenewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/renew',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close the session
 */
export const logout = <ThrowOnError extends boolean = false>(options: Options<LogoutData, ThrowOnError>) => (options.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Acknowledge the IsardVDI disclaimer
 */
export const acknowledgeDisclaimer = <ThrowOnError extends boolean = false>(options: Options<AcknowledgeDisclaimerData, ThrowOnError>) => (options.client ?? client).post<AcknowledgeDisclaimerResponses, AcknowledgeDisclaimerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/acknowledge-disclaimer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request an email verification
 */
export const requestEmailVerification = <ThrowOnError extends boolean = false>(options: Options<RequestEmailVerificationData, ThrowOnError>) => (options.client ?? client).post<RequestEmailVerificationResponses, RequestEmailVerificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/request-email-verification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify the user email
 */
export const verifyEmail = <ThrowOnError extends boolean = false>(options: Options<VerifyEmailData, ThrowOnError>) => (options.client ?? client).post<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/verify-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request a password reset
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordData, ThrowOnError>) => (options.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
    url: '/forgot-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset the user password
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>) => (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request a token for user migration
 *
 * Internal call from isard-api only. Users cannot call this endpoint
 */
export const migrateUser = <ThrowOnError extends boolean = false>(options: Options<MigrateUserData, ThrowOnError>) => (options.client ?? client).post<MigrateUserResponses, MigrateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/migrate-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate a API key for a specific user
 *
 * An API key will be created for the user with a durability of 1 year
 */
export const generateApiKey = <ThrowOnError extends boolean = false>(options: Options<GenerateApiKeyData, ThrowOnError>) => (options.client ?? client).put<GenerateApiKeyResponses, GenerateApiKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api-key',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate a token for a specific user
 *
 * Only admins, managers or external apps can call this endpoint
 */
export const impersonate = <ThrowOnError extends boolean = false>(options: Options<ImpersonateData, ThrowOnError>) => (options.client ?? client).post<ImpersonateResponses, ImpersonateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/impersonate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
